export const namespaced = true;

export const state = {
    loading: false,
    filters: {
        sortOrder: "Rating",
        selectedAirlines: [],
        unusedTicketsOnly: false,
        minPrice: 0,
        maxPrice: 20000,
        minPolicy: "",
        minRating: "",
        maxStopsSegment1: "",
        maxStopsSegment2: "",
        timeRangeSegment1: { segment: 0, range: [0, 24] },
        timeRangeSegment2: { segment: 0, range: [0, 24] },
        ndc: "",
        selectedJourneys: [],
        flightNumber: "",
        unusedTicketAirlines: []
      },
    recommendedItems: JSON.parse(localStorage.getItem("recommendedItems") || "[]"),
    selectedFlight: JSON.parse(localStorage.getItem("selectedFlight")),
    filterOptions: {},
    anchoredSearchContext: false,
    showFilterWarning: false,
    
}

export const mutations = {
    SET_LOADING(state, payload){
        state.loading = payload;
    },
    SET_FILTER_WARNING(state, boolean){
        state.showFilterWarning = boolean;
    },
    SET_FILTERS(state, payload){
        state.filters = payload;
    },
    UPDATE_FILTER_PROPERTY(state, payload) {
        this._vm.$set(state.filters, payload.key, payload.value);
    },
    SET_FILTER_OPTIONS(state, payload){
        state.filterOptions = payload;
    },
    SET_RECOMMENDED_ITEMS(state, payload){
        state.recommendedItems = payload;
    },
    SET_SELECTED_FLIGHT(state, payload){
        state.selectedFlight = payload;
    },
    RESET_FILTERS(state){
        state.filters = {
            sortOrder: "Rating",
            selectedAirlines: [],
            unusedTicketsOnly: false,
            minPrice: 0,
            maxPrice: 20000,
            minPolicy: "",
            minRating: "",
            maxStopsSegment1: "",
            maxStopsSegment2: "",
            timeRangeSegment1: { segment: 0, range: [0, 24] },
            timeRangeSegment2: { segment: 0, range: [0, 24] },
            ndc: "",
            selectedJourneys: [],
          }

        state.showFilterWarning = false;  
    },
    SET_ANCHORED_SEARCH_CONTEXT(state, payload){
        state.anchoredSearchContext = payload;
    }
}
